import React from "react";
import { Link } from "react-router-dom";
import LightMap from "../routecomponents/LightMap";
import Slogan from "../mapcomponents/Slogan";

function RoutePage() {
  return (
    <div>
      <Slogan
        main={"Find Your Well-Lit Path At Night"}
        sub={
          "Use your current location or pin the start and end points on the map."
        }
      />
      <LightMap />
    </div>
  );
}

export default RoutePage;
